// src/utils/logger.ts

// 根据环境决定是否输出日志
const isProduction = import.meta.env.PROD;

// 定义日志级别
export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

// 日志配置
const logConfig = {
  [LogLevel.DEBUG]: !isProduction,
  [LogLevel.INFO]: true,
  [LogLevel.WARN]: true,
  [LogLevel.ERROR]: true
};

// 日志工具类
export const logger = {
  debug: (...args: any[]) => {
    if (logConfig[LogLevel.DEBUG]) {
      console.log('[DEBUG]', ...args);
    }
  },
  info: (...args: any[]) => {
    if (logConfig[LogLevel.INFO]) {
      console.info('[INFO]', ...args);
    }
  },
  warn: (...args: any[]) => {
    if (logConfig[LogLevel.WARN]) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args: any[]) => {
    if (logConfig[LogLevel.ERROR]) {
      console.error('[ERROR]', ...args);
    }
  }
};
